import { PropsWithChildren, StrictMode } from "react"
import { Header } from "common/components/Header"
import { Footer } from "common/components/Footer"
import { PromosContext } from "modules/promos/contexts/PromosContext"
import { Slot } from "modules/promos/components/Slot/Slot"
import { useViewer } from "common/hooks/data/useViewer"
import { useRouter } from "common/lib/router"
import { NewHeader } from "common/components/NewHeader"

interface ContentProps {
  as?: "main" | "div"
}

// Reflects our custom layout value for  >= 2XL and >= LG viewports.
// Layout size is originaly  defined in `tc-container` CSS util class which exist in `common/styles/globals.css` file.
// However, we need to reuse this value in some of JS utils (for generating image 'sizes' attribute for example).
export const XXL_LAYOUT_WIDTH = 1356
export const LG_LAYOUT_WIDTH = 972

export const Content = ({ children, as: Tag = "main" }: PropsWithChildren<ContentProps>) => {
  return <Tag className="tc-container container mx-auto my-5">{children}</Tag>
}

export const Layout = ({ children }: PropsWithChildren<{}>) => {
  const currentYear = new Date().getFullYear()
  const { viewer } = useViewer()
  const router = useRouter()
  // To see the new header, a user must include a truthy value for the `newHeader` param in the URL.
  // In prod, they will also need to be logged in and have the `page_builder_new_header` feature
  // flip enabled.
  const shouldDisplayNewHeader =
    (process.env.NODE_ENV !== "production" || viewer?.user?.allow.newHeader) &&
    router?.query?.newHeader

  return (
    <StrictMode>
      <PromosContext>
        <div className="flex h-screen flex-col justify-between">
          {shouldDisplayNewHeader ? <NewHeader /> : <Header />}

          <Slot name="banner" />

          <Content>{children}</Content>
          <Footer year={currentYear} />
        </div>
        <div className="relative z-10">
          <Slot name="modal" />
        </div>
      </PromosContext>
    </StrictMode>
  )
}
